import React from 'react';

import { brand } from 'src/styles/colors';

/**
 * Square tile identifying a profile: its logo when it has one, otherwise a
 * monogram tinted with the profile's own primary colour. Used both by the
 * topbar indicator (24px) and by the rows of the switch-profile popover (26px).
 */
export const getProfileMonogram = (name?: string | null) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
};

interface ProfileTileProps {
  name?: string | null;
  logo?: string | null;
  color?: string | null;
  size?: number;
}

export const ProfileTile = ({
  name,
  logo,
  color,
  size = 24,
}: ProfileTileProps) => {
  const radius = size >= 26 ? 6 : 5;

  if (logo) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={logo}
        alt=""
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          objectFit: 'contain',
          background: '#fff',
          flex: 'none',
        }}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: color || brand.primary,
        color: '#fff',
        fontSize: size >= 26 ? 10 : 9,
        fontWeight: 900,
        letterSpacing: '0.3px',
        flex: 'none',
        userSelect: 'none',
      }}
    >
      {getProfileMonogram(name)}
    </span>
  );
};

export default ProfileTile;
